export const METHOD_PING = "PING";
export const METHOD_PONG = "PONG";

export const METHOD_INIT = "Init";
export const METHOD_GET_LICENSE_STATUS = "LicensingGetLicenseStatus";
export const METHOD_GET_LICENSE_REQUEST = "LicensingGetRequest";
export const METHOD_GET_AVAILABLE_LICENSE_PRODUCTS = "LicensingGetAvailableProducts";
export const METHOD_GET_AVAILABLE_LICENSE_PRODUCTS_ORDERED = "LicensingGetAvailableProductsOrdered";
export const METHOD_CREATE_LICENSE_REQUEST = "LicensingCreateRequest";
export const METHOD_REMOVE_LICENSE_REQUEST = "LicensingRemoveRequest";
export const METHOD_INSTALL_LICENSE = "LicensingInstallLicense";
export const METHOD_ONLINE_LICENSE_ACTIVATION_AVAILABLE = "LicensingOnlineActivationAvailable";
export const METHOD_ONLINE_LICENSE_COUNTS = "LicensingOnlineLicenseCounts";
export const METHOD_ONLINE_LICENSE_ACTIVATE = "LicensingOnlineActivate";
export const METHOD_ONLINE_LICENSE_UPDATE = "LicensingOnlineUpdateLicense";
export const METHOD_GET_SERVER_VERSION = "GetServerVersion";
export const METHOD_GET_SERVER_CONFIGURATION = "GetServerConfiguration";
export const METHOD_UPDATE_DATABASES = "UpdateDatabases";
export const METHOD_GET_LICENSE_INFO = "LicensingGetInfo";
export const METHOD_SET_CLIENT_IDENTIFIER = "SetClientIdentifier";
export const METHOD_GET_CLIENT_IDENTIFIER = "GetClientIdentifier";
export const METHOD_GET_INITIAL_DATA = "InitData";
export const METHOD_INSTALL_DATABASE_FILE_EXCEL = "InstallDatabaseFileExcel";
export const METHOD_INSTALL_DATABASE_FILE_EXE = "InstallDatabaseFileExe";
export const METHOD_INSTALL_DATABASE_FILE_ZIP = "InstallDatabaseFileZip";
export const METHOD_GET_DISABLED_PRODUCTS_STATUS = "GetDisabledProductsStatus";
export const METHOD_GET_DISABLED_FANDECKS_STATUS = "GetDisabledFandecksStatus";

export const METHOD_GET_LOGGED_USER = "GetLoggedUser";
export const METHOD_LOG_IN = "Login";
export const METHOD_LOG_OUT = "Logout";
export const METHOD_VALIDATE_USER_PASSWORD = "UserValidatePassword";

export const METHOD_GET_LAST_DISPENSED_FORMULAS = "GetLastDispensedColors";
export const METHOD_GET_ALL_FAVORITE_FORMULAS = "GetAllFavoriteColors";
export const METHOD_GET_ALL_COLORANTS = "GetAllColorants";
export const METHOD_GET_ALL_COLORANTS_FOR_BIP = "GetAllColorantsForBaseInProduct";
export const METHOD_GET_ALL_SERVER_COLORANTS = "GetAllServerColorants";
export const METHOD_GET_ALL_PRODUCTS = "GetAllProducts";
export const METHOD_GET_ALL_FANDECKS = "GetAllFandecks";
export const METHOD_GET_ALL_CUSTOM_FANDECKS = "GetAllCustomFandecks";
export const METHOD_GET_ALL_UNITS = "GetAllUnits";
export const METHOD_GET_ALL_USERS = "GetAllUsersList";
export const METHOD_GET_ALL_USER_GROUPS = "GetAllUserGroups";
export const METHOD_GET_SELECTED_USER_GROUPS = "getUserGroupsForUser";
export const METHOD_GET_ALL_CUSTOMERS = "GetAllCustomers";
export const METHOD_SEARCH_GLOBAL_FORMULAS = "GlobalSearch";
export const METHOD_GET_BASES_BY_PRODUCT = "GetBasesByProduct";
export const METHOD_GET_PACKAGES_BY_PARAMS = "GetPackagesByParams";
export const METHOD_GET_PACKAGES_BY_BASES = "GetPackagesByBases";
export const METHOD_GET_PRODUCT_IMAGE = "GetProductImage";
export const METHOD_GET_COLOR_IMAGE = "GetColorImage";
export const METHOD_GET_COLORANT_PACKAGE_IMAGE = "GetColorantPackageImage";
export const METHOD_GET_MASTER_PRODUCTS_BY_PRODUCT = "GetMasterProductAndZoneSiblingsById";
export const METHOD_GET_ALL_PROTOCOLS = "GetAllFileTransferProtocols";
export const METHOD_GET_ALL_IN_FORMATS = "GetAllFileTransferInFormats";
export const METHOD_GET_ALL_OUT_FORMATS = "GetAllFileTransferOutFormats";
export const METHOD_TEST_PROTOCOL = "TestFileTransferProtocol";
export const METHOD_ENABLE_PRODUCT = "EnableProduct";
export const METHOD_ENABLE_FANDECK = "EnableFandeck";
export const METHOD_GET_BATCHES_BY_COLORANT = "GetBatchesByColorant";
export const METHOD_GET_ALL_COLORANT_BATCHES = "GetAllColorantBatches";
export const METHOD_GET_ALL_TINTOMETRIC_SYSTEMS = "GetAllTintometricSystems";
export const METHOD_GET_ACTIVE_TINTOMETRIC_SYSTEM = "GetActiveTintometricSystem";
export const METHOD_GET_TINTOMETRIC_SYSTEM_ICON = "GetTintometricSystemIcon";

export const METHOD_GET_SETTING_OPTIONS = "GetSettings";
export const METHOD_GET_USER_SETTINGS = "GetOptions";
export const METHOD_SET_USER_SETTING = "SetOptions";
export const METHOD_EXPORT_SETTINGS = "ExportOptions";
export const METHOD_IMPORT_SETTINGS = "ImportOptions";
export const METHOD_RESTORE_SETTINGS = "RestoreOptions";
export const METHOD_EXPORT_STATIC_SQL = "ExportOptionsStaticSql";

export const METHOD_BROWSE_CIF = "BrowseColorsInFandecks";
export const METHOD_GENERATE_FANDECK_PREVIEW = "GenerateColorsInFandecksPreview";
export const METHOD_GET_AVAILABLE_FORMULAS = "GetAvailableFormulas";
export const METHOD_GET_BUILDING_SITES = "GetBuildingSites";
export const METHOD_GET_CALCULATED_FORMULA = "GetCalculatedFormula";
export const METHOD_GET_CLOSEST_COLOR = "GetClosestColorForCompetitiveColor";
export const METHOD_GET_CLOSEST_COLOR_WITH_PRICES = "GetClosestColorForCompetitiveColorWithPrices";
export const METHOD_GET_COLOR_IN_FANDECK = "GetColorInFandeck";
export const METHOD_GET_COLOR_IN_FANDECK_DATA = "GetColorInFandeckData";
export const METHOD_GET_CUSTOM_FORMULA = "GetCustomFormula";
export const METHOD_GET_CUSTOMERS_BY_PARAMS = "GetCustomersByParams";
export const METHOD_GET_FILE = "GetFile";
export const METHOD_GET_FILE_INFO = "GetFileInfo";
export const METHOD_GET_FILE_PAGE_PREVIEW = "GetFilePagePreview";
export const METHOD_GET_FORMULA_DETAIL = "GetFormulaDetail";
export const METHOD_GET_FORMULA_META_AND_PRINT_DATA = "GetMetaData2";
export const METHOD_GET_FORMULA_NOTE_IMAGE = "GetFormulaNoteImage";
export const METHOD_GET_FORMULA_VALIDATION_ERRORS = "GetFormulaValidationErrors";
export const METHOD_GET_LAST_CUSTOMERS = "GetLastCustomerActions";
export const METHOD_REBOOT_COMPUTER = "RebootComputer";
export const METHOD_RECALCULATE_FORMULA = "RecalculateFormula";
export const METHOD_SEARCH_BASES = "SearchBases";
export const METHOD_SEARCH_BIPP = "SearchBaseInProductPackages";
export const METHOD_SEARCH_COLORS = "SearchColors";
export const METHOD_SEARCH_FANDECKS = "SearchFandecks";
export const METHOD_SEARCH_PRODUCTS = "SearchProducts";
export const METHOD_SET_ORDER_MORE_INFO = "SetOrderMoreInfo";
export const METHOD_SET_ORDER_STATUS = "SetOrderStatus";
export const METHOD_SHUTDOWN_COMPUTER = "ShutdownComputer";
export const METHOD_UNLOCK_COMPUTER = "UnlockPc";

export const METHOD_GET_CUSTOMER_DETAIL = "GetCustomer";
export const METHOD_ADD_CUSTOMER = "AddCustomer";
export const METHOD_EDIT_CUSTOMER = "EditCustomer";
export const METHOD_DELETE_CUSTOMER = "RemoveCustomer";
export const METHOD_GET_CUSTOMER_BY_EMAIL = "GetCustomerByEmail";

export const METHOD_GET_ALL_CURRENCIES = "GetAllCurrencies";
export const METHOD_SET_CURRENCY = "SetCurrency";
export const METHOD_GET_CURRENCY = "GetCurrency";
export const METHOD_EDIT_CURRENCY = "EditCurrency";
export const METHOD_DELETE_CURRENCY = "DeleteCurrency";
export const METHOD_ADD_CURRENCY = "AddCurrency";

export const METHOD_ADD_FAVORITE_FORMULA = "AddFavoriteColor";
export const METHOD_REMOVE_FAVORITE_FORMULA = "RemoveFavoriteColor";
export const METHOD_ADD_FAVORITE_FOLDER = "AddFavoriteFolder";
export const METHOD_EDIT_FAVORITE_FOLDER = "EditFavoriteFolder";
export const METHOD_REMOVE_FAVORITE_FOLDER = "RemoveFavoriteFolder";
export const METHOD_MOVE_FAVORITE_FORMULA = "MoveFavoriteColor";

export const METHOD_ADD_CUSTOM_FANDECK = "AddCustomFandeck";
export const METHOD_ADD_CUSTOM_FORMULA = "AddCustomFormula";
export const METHOD_ADD_CUSTOM_FORMULA_FROM_XML = "AddCustomFormulaFromXml";
export const METHOD_DELETE_CUSTOM_FORMULA = "DeleteCustomFormula";
export const METHOD_EDIT_CUSTOM_FANDECK = "EditCustomFandeck";
export const METHOD_CHECK_CUSTOM_FORMULA = "CheckCustomFormulaCombination";
export const METHOD_CHECK_CUSTOM_CIF = "CheckCustomColorAndFandeckCombination";
export const METHOD_CHECK_CUSTOM_FORMULA_FROM_XML = "CheckCustomFormulaCombinationFromXml";
export const METHOD_REMOVE_CUSTOM_FANDECK = "RemoveCustomFandeck";

export const METHOD_GET_BASE_IN_PRODUCT_PACKAGE_BARCODES = "GetBaseInProductPackageBarcodes";
export const METHOD_VALIDATE_BASE_IN_PRODUCT_PACKAGE_BARCODE = "ValidateBaseInProductPackageBarcode";

export const METHOD_RCC_GET_VERSION = "GetVersion";
export const METHOD_MACHINE_IS_SELECTED = "MachineIsSelected";
export const METHOD_MACHINE_IS_CONNECTING = "MachineIsConnecting";
export const METHOD_MACHINE_IS_CONNECTED = "MachineIsConnected";
export const METHOD_MACHINE_IS_BUSY = "MachineIsBusy";
export const METHOD_MACHINE_START_CONNECT = "MachineStartConnect";
export const METHOD_MACHINE_START_DISCONNECT = "MachineStartDisconnect";
export const METHOD_GET_DRIVER_CONFIGURATION = "MachineGetDriverConfiguration";
export const METHOD_SET_DRIVER_CONFIGURATION = "MachineSetDriverConfiguration";
export const METHOD_MACHINE_GET_CONFIGURATION = "MachineGetConfiguration";
export const METHOD_GET_DRIVER_TYPES = "MachineGetDriverTypes";
export const METHOD_GET_SPECTRO_CONFIGURATION = "SpectroGetConfiguration";
export const METHOD_SET_SPECTRO_CONFIGURATION = "SpectroSetConfiguration";
export const METHOD_MACHINE_SET_CONFIGURATION = "MachineSetConfiguration";
export const METHOD_GET_SPECTRO_TYPES = "SpectroGetTypes";
export const METHOD_GET_SPECTRO_XRITE_MODELS = "SpectroGetXriteModels";
export const METHOD_GET_SPECTRO_COM_PORTS = "SpectroGetComPorts";
export const METHOD_MACHINE_GET_CALLS = "MachineGetAllCalls";
export const METHOD_MACHINE_INFO = "MachineGetInfo";
export const METHOD_MACHINE_DEVICES = "MachineGetDevices";
export const METHOD_MACHINE_CANISTER_BATCH_NUMBERS = "MachineCanisterBatchNumbers";
export const METHOD_MACHINE_CANISTERS = "MachineGetCanisters";
export const METHOD_MACHINE_CHANNELS = "MachineGetChannels";
export const METHOD_MACHINE_START_INITIALIZE = "MachineStartInitialize";
export const METHOD_MACHINE_START_RESET = "MachineStartReset";
export const METHOD_MACHINE_START_HARD_RESET = "MachineStartHardReset";
export const METHOD_MACHINE_START_ERRORS_RESET = "MachineStartErrorsReset";
export const METHOD_MACHINE_GET_ERRORS = "MachineGetErrors";
export const METHOD_MACHINE_GET_ERROR_DETAILS = "MachineGetErrorDetails";
export const METHOD_MACHINE_GET_ERROR_IMAGE = "MachineGetErrorImage";
export const METHOD_MACHINE_GET_CANISTER_IMAGE = "MachineGetCanisterImage";
export const METHOD_MACHINE_SET_CANISTER_BARCODE = "MachineSetCanisterBarcode";
export const METHOD_MACHINE_SET_CANISTER_THRESHOLD_PERCENT = "MachineSetCanisterThresholdPercent";
export const METHOD_MACHINE_VALIDATE_FORMULA = "MachineValidateDispenseFormula";
export const METHOD_MACHINE_MANUAL_FORMULA = "MachineDispenseManualFormula";
export const METHOD_MACHINE_START_DISPENSE_FORMULA = "MachineStartDispenseFormula";
export const METHOD_MACHINE_GET_DIALOG = "MachineGetDialog";
export const METHOD_MACHINE_DIALOG_BUTTON_CLICK = "MachineDialogButtonClick";
export const METHOD_MACHINE_MOVE_TABLE_TO_REFILL = "MachineStartMoveTableToRefill";
export const METHOD_MACHINE_ADD_CANISTER_LEVEL = "MachineAddCanisterLevel";
export const METHOD_MACHINE_SET_CANISTER_LEVEL = "MachineSetCanisterLevel";
export const METHOD_MACHINE_SET_MAX_DISPENSE_LEVEL = "MachineSetCanisterMaxDispenseAmount";
export const METHOD_MACHINE_SET_CANISTER_DISPENSE_LOGIC_TYPE = "MachineSetCanisterDispenseLogicType";
export const METHOD_MACHINE_START_CANISTER_REFILL = "MachineStartRefillCanister";
export const METHOD_MACHINE_START_SHELF = "MachineStartShelf";
export const METHOD_MACHINE_START_PUNCH = "MachineStartPunch";
export const METHOD_MACHINE_START_PLUG = "MachineStartPlug";
export const METHOD_MACHINE_START_CAP = "MachineStartCap";
export const METHOD_MACHINE_SHOW_SERVICE_WINDOW = "MachineShowServiceWindow";
export const METHOD_MACHINE_START_CLEAN_CHANNELS = "MachineStartCleanChannels";
export const METHOD_MACHINE_START_CLEAN_ALL = "MachineStartCleanAll";
export const METHOD_MACHINE_START_RECIRCULATE_CHANNELS = "MachineStartRecirculateChannels";
export const METHOD_MACHINE_START_RECIRCULATE_ALL = "MachineStartRecirculateAll";
export const METHOD_MACHINE_START_STIR_CANISTERS = "MachineStartStirCanisters";
export const METHOD_MACHINE_START_STIR_ALL = "MachineStartStirAll";
export const METHOD_MACHINE_START_PURGE = "MachineStartPurgeFormula";
export const METHOD_MACHINE_START_PURGE_ALL = "MachineStartPurgeAll";
export const METHOD_MACHINE_START_SMART_PURGE = "MachineStartSmartPurgeChannels";
export const METHOD_MACHINE_START_SMART_PURGE_ALL = "MachineStartSmartPurgeAll";
export const METHOD_MACHINE_HISTORY_ACTIONS = "MachineGetHistoryActions";
export const METHOD_MACHINE_HISTORY_REFILLS = "MachineGetHistoryRefills";
export const METHOD_MACHINE_GET_SENSORS = "MachineGetSensors";
export const METHOD_MACHINE_HISTORY_LAST_ACTIONS = "MachineHistoryLastActions";
export const METHOD_MACHINE_GET_CANISTER_BY_BARCODE = "MachineGetCanisterByBarcode";
export const METHOD_RCC_SET_COLORANTS = "SetColorants";
export const METHOD_MACHINE_GET_UNITS = "MachineGetUnits";
export const METHOD_MACHINE_GET_PURGE_STATS = "MachineChannelPurgeStats";
export const METHOD_MACHINE_GET_DISPENSE_STATS = "MachineChannelDispenseStats";
export const METHOD_MACHINE_GET_ALL_STATS = "MachineChannelAllStats";
export const METHOD_MACHINE_GET_CANISTER_BATCH_NUMBERS = "MachineCanisterBatchNumbersByParams";
export const METHOD_MACHINE_SET_CANISTER_UFI_CODE = "MachineSetCanisterUfiCode";
export const METHOD_MACHINE_GET_CANISTER_UFI_CODES = "MachineCanisterUfiCodesByParams";
export const METHOD_MACHINE_GET_MESSAGES = "MachineGetMessages";

export const METHOD_MACHINE_PURGE_RULES_LIST = "MachinePurgeRulesList";
export const METHOD_MACHINE_PURGE_RULE_ADD = "MachinePurgeRuleAdd";
export const METHOD_MACHINE_PURGE_RULE_UPDATE = "MachinePurgeRuleUpdate";

export const METHOD_MACHINE_GET_AUTOTASKS = "MachineAutotasksList";
export const METHOD_MACHINE_START_AUTOTASK = "MachineStartAutotasksRunOnStart";
export const METHOD_MACHINE_AUTOTASK_DELETE = "MachineAutotaskDelete";
export const METHOD_MACHINE_AUTOTASK_ADD_GENERIC = "MachineAutotaskAddGeneric";
export const METHOD_MACHINE_AUTOTASK_UPDATE_GENERIC = "MachineAutotaskUpdateGeneric";
export const METHOD_MACHINE_GET_AVAILABLE_AUTOTASK_TYPES = "MachineGetAvailableAutotaskActionTypes";
export const METHOD_GET_PACKAGES_FOR_COLORANT = "GetPackagesForColorant";

export const METHOD_MACHINE_BACKUP_CONFIGURATION = "MachineBackupConfiguration";

export const MACHINE_EVENT_CONNECT_DONE = "MachineConnectDone";
export const MACHINE_EVENT_DISCONNECT_DONE = "MachineDisconnectDone";
export const MACHINE_EVENT_INITIALIZE_DONE = "MachineInitializeDone";
export const MACHINE_EVENT_RESET_DONE = "MachineResetDone";
export const MACHINE_EVENT_HARD_RESET_DONE = "MachineHardResetDone";
export const MACHINE_EVENT_ERRORS_RESET_DONE = "MachineErrorsResetDone";
export const MACHINE_EVENT_DISPENSE_FORMULA_DONE = "MachineDispenseFormulaDone";
export const MACHINE_EVENT_DISPENSE_CANISTER_STARTED = "MachineDispenseCanisterStarted";
export const MACHINE_EVENT_DISPENSE_CANISTER_DONE = "MachineDispenseCanisterDone";
export const MACHINE_EVENT_DISPENSE_CANISTER_ERROR = "MachineDispenseCanisterError";
export const MACHINE_EVENT_MOVE_TABLE_TO_REFILL_DONE = "MachineMoveTableToRefillDone";
export const MACHINE_EVENT_SHELF_DONE = "MachineShelfDone";
export const MACHINE_EVENT_PUNCH_DONE = "MachinePunchDone";
export const MACHINE_EVENT_PLUG_DONE = "MachinePlugDone";
export const MACHINE_EVENT_CAP_DONE = "MachineCapDone";
export const MACHINE_EVENT_SERVICE_WINDOW_DONE = "MachineShowServiceWindowDone";
export const MACHINE_EVENT_CLEAN_DONE = "MachineCleanChannelsDone";
export const MACHINE_EVENT_CLEAN_ALL_DONE = "MachineCleanAllDone";
export const MACHINE_EVENT_RECIRCULATE_DONE = "MachineRecirculateChannelsDone";
export const MACHINE_EVENT_RECIRCULATE_ALL_DONE = "MachineRecirculateAllChannelsDone";
export const MACHINE_EVENT_STIR_DONE = "MachineStirCanistersDone";
export const MACHINE_EVENT_STIR_ALL_DONE = "MachineStirAllDone";
export const MACHINE_EVENT_PURGE_DONE = "MachinePurgeFormulaDone";
export const MACHINE_EVENT_PURGE_ALL_DONE = "MachinePurgeAllDone";
export const MACHINE_EVENT_SMART_PURGE_DONE = "MachineSmartPurgeChannelsDone";
export const MACHINE_EVENT_SMART_PURGE_ALL_DONE = "MachineSmartPurgeAllDone";
export const PRINTER_EVENT_JPG_EXPORT_DONE = "PrintingExportReportToJpgDone";
export const PRINTER_EVENT_PDF_EXPORT_DONE = "PrintingExportReportToPdfDone";
export const MACHINE_EVENT_AUTOTASK_DONE = "MachineAutotasksOnStartDone";
export const MACHINE_EVENT_AUTOTASK_ADDED = "MachineAutotaskAdded";
export const MACHINE_EVENT_AUTOTASK_DELETED = "MachineAutotaskDeleted";
export const MACHINE_EVENT_AUTOTASK_UPDATED = "MachineAutotaskUpdated";
export const MACHINE_EVENT_SENSORS_UPDATED = "MachineSensorsUpdated";
export const MACHINE_EVENT_LAST_ACTIONS_UPDATED = "MachineLastActionsUpdated";

export const MACHINE_EVENT_BUSY = "MachineBusy";
export const MACHINE_EVENT_IDLE = "MachineIdle";
export const MACHINE_EVENT_DIALOG_SHOW = "MachineDialogShow";
export const MACHINE_EVENT_DIALOG_HIDE = "MachineDialogHide";
export const MACHINE_EVENT_PROGRESS_UPDATED = "MachineProgressUpdated";
export const MACHINE_EVENT_PROGRESS_CLEARED = "MachineProgressCleared";
export const MACHINE_EVENT_ERRORS_UPDATED = "MachineErrorsUpdated";

export const METHOD_SPECTRO_IS_SELECTED = "SpectroIsSelected";
export const METHOD_SPECTRO_IS_CONNECTED = "SpectroIsConnected";
export const METHOD_SPECTRO_IS_CALIBRATED = "SpectroIsCalibrated";
export const METHOD_SPECTRO_START_CONNECT = "SpectroStartConnect";
export const METHOD_SPECTRO_GET_CALLS = "SpectroGetAllCalls";
export const METHOD_SPECTRO_GET_INFO = "SpectroGetInfo";
export const METHOD_SPECTRO_GET_DIALOG = "SpectroGetDialog";
export const METHOD_SPECTRO_DIALOG_BUTTON_CLICK = "SpectroDialogButtonClick";
export const METHOD_SPECTRO_START_CALIBRATE = "SpectroStartCalibrate";
export const METHOD_SPECTRO_START_MEASURE = "SpectroStartMeasure";
export const METHOD_SPECTRO_START_DISCONNECT = "SpectroStartDisconnect";

export const SPECTRO_EVENT_CONNECT_DONE = "SpectroConnectDone";
export const SPECTRO_EVENT_DIALOG_SHOW = "SpectroDialogShow";
export const SPECTRO_EVENT_DIALOG_HIDE = "SpectroDialogHide";
export const SPECTRO_EVENT_CALIBRATE_DONE = "SpectroCalibrateDone";
export const SPECTRO_EVENT_MEASURE_DONE = "SpectroMeasureDone";
export const SPECTRO_EVENT_PREVIEW_UPDATE = "SpectroPreviewUpdate";
export const SPECTRO_EVENT_DISCONNECT_DONE = "SpectroDisconnectDone";

export const METHOD_GET_COLORS_BY_SPECTRO_DELTA = "GetColorsBySpectroDelta2";

export const METHOD_RCC_PRINT_FORMULA_SILENT = "PrintingStartPrintReportSilent";

export const METHOD_EDIT_PACKAGE_PRICE = "EditPackagePrice";

// Pricing
export const METHOD_PRICING_GET_GENERIC_DATA = "PricingGetGenericData";
export const METHOD_PRICING_SET_GENERIC_DATA = "PricingSetGenericData";
export const METHOD_PRICING_GET_GENERIC_COLORANT_DATA = "PricingGetGenericColorantData";
export const METHOD_PRICING_SET_GENERIC_COLORANT_DATA = "PricingSetGenericColorantData";
export const METHOD_PRICING_GET_GENERIC_PACKAGE_DATA = "PricingGetGenericPackageData";
export const METHOD_PRICING_SET_GENERIC_PACKAGE_DATA = "PricingSetGenericPackageData";
export const METHOD_PRICING_GET_GENERIC_PRODUCT_DATA = "PricingGetGenericProductData";
export const METHOD_PRICING_SET_GENERIC_PRODUCT_DATA = "PricingSetGenericProductData";
export const METHOD_PRICING_GET_COLORANTS_DATA = "PricingGetColorantsData";
export const METHOD_PRICING_SET_COLORANT_DATA = "PricingSetColorantData";
export const METHOD_PRICING_GET_PACKAGES_DATA = "PricingGetPackagesData";
export const METHOD_PRICING_SET_PACKAGE_DATA = "PricingSetPackageData";
export const METHOD_PRICING_GET_BASE_IN_PRODUCTS_DATA = "PricingGetBaseInProductsData";
export const METHOD_PRICING_GET_BASE_IN_PRODUCTS_AND_PACKAGES_DATA = "PricingGetBaseInProductsAndPackagesData";
export const METHOD_PRICING_SET_BASE_IN_PRODUCT_DATA = "PricingSetBaseInProductData";
export const METHOD_PRICING_SET_BASE_IN_PRODUCT_PACKAGE_DATA = "PricingSetBaseInProductPackageData";
export const METHOD_PRICING_IMPORT_DATA = "ImportPricingData";
export const METHOD_GET_PRICE_SETTINGS = "GetPriceOptions";
export const METHOD_GET_PRICE_SETTING = "GetSinglePriceOptionValue";
export const METHOD_SET_PRICE_SETTING = "SetSinglePriceOptionValue";

// Download files
export const METHOD_PREPARE_FILE = "PrepareFile";
export const METHOD_PREPARE_FILE_BYTES = "GetPreparedFileBytes";
export const METHOD_RELEASE_PREPARED_FILE = "ReleasePreparedFile";

// Margin settings
export const METHOD_GET_ALL_MARGINS = "GetAllMargins";
export const METHOD_ADD_MARGIN = "AddMargin";
export const METHOD_EDIT_MARGIN = "EditMargin";
export const METHOD_REMOVE_MARGIN = "RemoveMargin";
export const METHOD_MOVE_UP_MARGIN = "MoveUpMargin";
export const METHOD_MOVE_DOWN_MARGIN = "MoveDownMargin";

// Margin pricing
export const METHOD_MARGIN_SET_COLORANT_DATA = "MarginSetColorantData";
export const METHOD_MARGIN_SET_BASE_IN_PRODUCT_DATA = "MarginSetBaseInProductData";
export const METHOD_MARGIN_SET_BASE_IN_PRODUCT_PACKAGE_DATA = "MarginSetBaseInProductPackageData";

// User settings
export const METHOD_ADD_USER = "InsertUser";
export const METHOD_DELETE_USER = "DeleteUser";
export const METHOD_RESTORE_USER = "METHOD_RESTORE_USER";
export const METHOD_UPDATE_USER = "UpdateUser";
export const METHOD_ADD_USER_INTO_GROUP = "insertUserIntoGroup";
export const METHOD_REMOVE_USER_FROM_GROUP = "removeUserFromGroup";
export const METHOD_REMOVE_USER_FROM_ALL_GROUPS = "removeUserFromAllGroups";
export const METHOD_CHANGE_USER_PASSWORD = "UserChangePassword";

export const METHOD_GET_ORDER_DETAIL = "GetOrderDetail";
export const METHOD_MY_ORDERS_GET_DATA = "GetMyOrders";
export const METHOD_TO_DISPENSE_GET_ORDERS = "GetToDispenseOrders";
export const METHOD_ASSIGN_ORDER = "AcquireOrder";
export const METHOD_RELEASE_ORDER = "ReleaseOrder";

export const METHOD_GET_STATISTICS = "GetStats";
export const METHOD_GET_STATISTICS_DATA = "GetStatData";
export const METHOD_GET_STATISTICS_DETAIL = "GetStatDetails2";
export const METHOD_SET_STATISTIC_HIDDEN = "SetStatHidden";
export const METHOD_SET_STATISTIC_MORE_INFO = "SetStatMoreInfo";
export const METHOD_SET_STATISTIC_COLOR_DIFFERENCE = "SetStatColorDifference";

export const METHOD_ADD_QUICK_TINT_INTO_STATISTICS = "AddQuickTintToStats";
export const METHOD_ADD_COLOR_STATS = "AddColorStats";
export const METHOD_ADD_COLOR_STATS_CORRECTION = "AddColorStatsCorrection";
export const METHOD_ADD_COLOR_STATS_FROM_ORDER = "AddColorStatsFromOrder";
export const METHOD_ADD_COLOR_STATS_FROM_STATS = "AddColorStatsFromStats";
export const METHOD_ADD_DISPENSED_PACKAGE = "AddDispensedPackage";
export const METHOD_FINISH_DISPENSED_PACKAGE = "FinishDispensedPackage";
export const METHOD_ADD_ORDER_RECORD = "AddOrderRecord";
export const METHOD_ADD_ORDER_RECORD_BY_ORDER_BARCODE = "AddOrderRecordByOrderBarcode";
export const METHOD_ADD_ORDER_RECORD_BY_HISTORY_BARCODE = "AddOrderRecordByHistoricOrderBarcode";
export const METHOD_ADD_AND_FINISH_ALL_DISPENSED_PACKAGE = "AddAndFinishAllDispensedPackages";
export const METHOD_GET_CORRECTION_HISTORY = "GetStatsTree";

export const METHOD_GET_DATABASES_LIST = "GetDatabasesList";
export const METHOD_GET_DATABASES_READY_FOR_PARTIAL_UPDATES = "GetDatabasesReadyForPartialUpdates";
export const METHOD_GET_ACTIVE_DATABASE = "GetActiveDatabase";
export const METHOD_SET_ACTIVE_DATABASE = "SetActiveDatabase";
export const METHOD_GET_DATABASE_IMAGE = "GetDatabaseImage";
export const METHOD_GET_AVAILABLE_SERVERS = "GetRedlikeServers";
export const METHOD_DISCOVER_SERVERS = "DiscoverRedlikeServers";
export const METHOD_ADD_SERVER = "AddRedlikeServer";
export const METHOD_EDIT_SERVER = "EditRedlikeServer";
export const METHOD_DELETE_REDLIKE_SERVERS = "DeleteInvalidRedlikeServers";

export const METHOD_GET_ITEM_BY_BARCODE = "GetItemByBarcode";
export const GET_COLORANT_PACKAGE_BARCODE = "GetColorantPackageBarcode";

export const METHOD_INTERGAMMA_GET_DISPENSED_ORDERS_BY_CUSTOMER_ID = "GetDispensedOrdersByCustomerId";

export const METHOD_SET_POS_INFO = "SetPosInfo";
export const METHOD_SET_REGISTRATION_DATA = "LicensingSetRegistrationData";
export const METHOD_GET_REGISTRATION_DATA = "LicensingGetRegistrationData";

// Server export files
export const METHOD_EXPORT_LOCAL_DB = "export_local_db";
export const METHOD_EXPORT_LOCAL_FILE = "save_local_file_to_path";
export const METHOD_EXPORT_PRICING_DATA = "export_pricing_data";
export const METHOD_EXPORT_STATS = "export_stats";

// RCC export files
export const MACHINE_EXPORT_CHANNEL_ALL_STATS = "MachineExportChannelAllStats";
export const MACHINE_EXPORT_CHANNEL_DISPENSE_STATS = "MachineExportChannelDispenseStats";
export const MACHINE_EXPORT_CHANNEL_PURGE_STATS = "MachineExportChannelPurgeStats";

// Server events
export const SERVER_EVENT_SERVERS_UPDATED = "servers_updated";
export const SERVER_EVENT_ORDERS_LIST_UPDATED = "orders_list_updated";
export const SERVER_EVENT_ORDER_STATE_CHANGED = "order_state_changed";
export const SERVER_EVENT_PROGRESS = "progress";
export const SERVER_EVENT_LAST_DISPENSED_UPDATED = "last_dispensed_colors_updated";
export const SERVER_EVENT_DATABASE_UPDATE_IN_PROGRESS = "database_update_in_progress";
export const SERVER_EVENT_DATABASE_UPDATE_FINISHED = "database_update_finished";
export const SERVER_EVENT_DATABASE_IMPORT_ITEM = "database_import_item";
export const SERVER_EVENT_DATABASE_IMPORT_STEP = "database_import_step";
export const SERVER_EVENT_FILE_TRANSFER_CUSTOMER = "file_transfer_customer_processed";
export const SERVER_EVENT_FILE_TRANSFER_CUSTOM_FORMULA = "file_transfer_custom_formula_processed";
export const SERVER_EVENT_FILE_TRANSFER_HISTORY = "file_transfer_history_processed";
export const SERVER_EVENT_FILE_TRANSFER_ORDER = "file_transfer_order_processed";
export const SERVER_EVENT_FILE_TRANSFER_FINISHED = "file_transfer_process_data_finished";
export const SERVER_EVENT_FILE_TRANSFER_FILE_AVAILABLE = "file_transfer_file_available";
export const SERVER_EVENT_FILE_TRANSFER_STARTED = "file_transfer_process_data_started";
export const SERVER_EVENT_FILE_TRANSFER_FORMAT = "error_file_transfer_format";
export const SERVER_EVENT_FILE_TRANSFER_FORMAT_IN = "error_file_transfer_in_format";
export const SERVER_EVENT_FILE_TRANSFER_FORMAT_OUT = "error_file_transfer_out_format";
export const SERVER_EVENT_PARTIAL_UPDATE_APPLIED = "partial_update_applied";
export const SERVER_EVENT_PARTIAL_UPDATE_PREPARING = "partial_update_preparing";
export const SERVER_EVENT_PARTIAL_UPDATE_PREPARED = "partial_update_prepared";
export const SERVER_EVENT_SHOW_MESSAGE = "show_message";
export const SERVER_EVENT_TICKET_ANSWERED = "ticket_answered";
export const SERVER_EVENT_TICKET_DELIVERED = "ticket_delivered";

export const METHOD_PRINTER_GET_DEFAULT = "PrintingGetDefaultPrinter";
export const METHOD_PRINTER_GET_PRINTERS_LIST = "PrintingGetPrintersList";
export const METHOD_PRINTER_GET_TEMPLATES_LIST = "PrintingGetTemplatesList";
export const METHOD_PRINTER_START_JPG_EXPORT = "PrintingStartExportReportToJpg";
export const METHOD_PRINTER_START_PDF_EXPORT = "PrintingStartExportReportToPdf";

export const METHOD_SUPPORTED_IMPORT_CUSTOM_DATA_FORMATS = "SupportedImportCustomDataFormats";
export const METHOD_IMPORT_CUSTOM_DATA = "ImportCustomData";
export const METHOD_DELETE_DISPENSING_HISTORY = "DeleteDispensingHistory";
export const METHOD_ABORT_CUSTOM_DATA_IMPORTING = "AbortCustomDataImporting";
export const METHOD_DELETE_IMPORTED_CUSTOM_DATA = "DeleteImportedCustomData";

// Ticketing methods
export const METHOD_CREATE_TICKET = "CreateTicket";
export const METHOD_DELETE_TICKET = "DeleteTickets";
export const METHOD_GET_SERVICE_DEPARTMENTS = "GetServiceDepartments";
export const METHOD_GET_TICKETS = "GetTickets";
export const METHOD_MARK_TICKET_AS_READ = "MarkTicketAsRead";

// TMC
export const METHOD_GET_TMC_CONNECTION_STATUS = "GetTmcConnectionStatus";

// Helper Server methods
export const METHOD_HELPER_IS_ONLINE = "is_online";
export const METHOD_HELPER_SEND_ERROR_REPORT = "send_error_report";
export const METHOD_HELPER_SET_CONFIGURATION = "set_configuration";
export const METHOD_HELPER_SAVE_LOG_FILES = "save_log_files";
export const METHOD_HELPER_DIALOG_BUTTON_CLICK = "dialog_button_click";
export const METHOD_HELPER_PREPARE_LOG_FILE = "prepare_log_files_archive";
export const METHOD_HELPER_GET_PREPARED_LOG_ARCHIVE = "get_prepared_log_files_archive_bytes";
export const METHOD_HELPER_RELEASE_LOG_ARCHIVE = "release_log_files_archive";
export const METHOD_HELPER_RESTART_SERVER = "restart_redlike_server";

// Helper Server events
export const HELPER_EVENT_CONFIGURATION_UPDATED = "configuration_updated";
export const HELPER_EVENT_SHOW_DIALOG = "show_dialog";
export const HELPER_EVENT_HIDE_DIALOG = "hide_dialog";
export const HELPER_EVENT_UPDATE_DIALOG = "update_dialog";
export const HELPER_EVENT_MINIMIZE_CLIENT_APP = "minimize_client_app";
export const HELPER_EVENT_DOWNLOAD_PROGRESS = "download_progress";
export const HELPER_EVENT_SHOW_NOTIFICATION = "show_notification";
export const HELPER_EVENT_START_APPLICATION = "start_application";
export const HELPER_EVENT_DATABASE_INFO_UPDATED = "db_info_updated";
export const HELPER_EVENT_SOFTWARE_STATUS_UPDATED = "sw_status_updated";

// Server banners
export const METHOD_GET_ALL_BANNERS = "GetAllBanners";
export const METHOD_GET_BANNER_IMAGE = "GetBannerImage";

// Stock
export const METHOD_MACHINE_COLORANT_PREDICTION = "MachineColorantPrediction";
export const METHOD_STOCK_ADD_COLORANT_PACKAGES = "AddColorantPackagesToStock";
export const METHOD_STOCK_ADD_COLORANT_PACKAGES_ORDERS = "AddColorantPackageOrdersToStock";
export const METHOD_STOCK_GET_COLORANT_PACKAGES = "GetColorantPackagesFromStock";
export const METHOD_STOCK_REMOVE_COLORANT_PACKAGE = "RemoveColorantPackageFromStock";
export const METHOD_STOCK_SET_PREDICTION_FOR_COLORANT_PACKAGE = "SetPredictionForColorantPackageStock";

// Matching
export const METHOD_MATCHING_INIT = "MatchingInit";
export const METHOD_MATCHING_CAN_BE_USED = "MatchingCanBeUsed";
export const METHOD_GET_PRODUCTS_AVAILABLE_FOR_MATCHING = "GetProductsAvailableForMatching";
export const METHOD_GET_COLOR_FILES_FOR_PRODUCT = "GetColorFilesForProduct";
export const METHOD_GET_COLOR_FILE_DETAIL = "GetColorFileDetail";
export const METHOD_GET_COLOR_MATCH_DATA = "GetColorMatchData";
export const METHOD_GET_FORMULA_CORRECTION_DATA = "GetFormulaCorrectionData";
export const METHOD_COMPARE_COLORS_QUALITY_CONTROL = "CalculateColorDifference";
export const METHOD_GET_FORMULA_REFORMULATION_DATA = "GetFormulaReformulationData";

// Partial updates
export const METHOD_GET_ALL_PREPARED_UPDATES_PER_DATABASE = "GetAllPreparedUpdatesPerDatabase";
export const METHOD_APPLY_ALL_PREPARED_UPDATES_PER_DATABASE = "ApplyAllPreparedUpdatesPerDatabase";
export const METHOD_GET_PREPARED_PARTIAL_UPDATES_COUNT = "GetPreparedPartialUpdatesCount";
